import { Inbox } from "lucide-react";

export default function EmptyState({ title = "Belum ada data", description = "Belum ada data untuk ditampilkan.", action }) {
  return (
    <div className="empty-state">
      <div className="empty-state-icon"><Inbox className="w-5 h-5" /></div>
      <div className="font-semibold text-slate-700">{title}</div>
      <div className="text-xs text-slate-500 max-w-sm">{description}</div>
      {action}
    </div>
  );
}
